import {getSearchResultsAtRoot, MediocreSearchResultProps} from '../search/SearchResultProps';
import {MediocreSearchResult} from '../search/SearchResults';
import FormattersConstants, {ExtendedFormat, Format} from './FormattersConstants';

interface FormattedTextSearchData {
  formattedText: {start: number; end: number};
}

export function makeFormattedTextSearchResultData(start: number, end: number): FormattedTextSearchData {
  return {
    formattedText: {start, end},
  };
}

export function isFormatTextSearchData(
  result: MediocreSearchResult
): result is MediocreSearchResult & {data: FormattedTextSearchData} {
  return (result.data as FormattedTextSearchData)?.formattedText != null;
}

export function addSearchResultsToFormats(formats: Format, props: MediocreSearchResultProps): ExtendedFormat {
  const {selected, results} = getSearchResultsAtRoot(props);
  if (results.length === 0) {
    return formats;
  }
  return {
    ...formats,
    [FormattersConstants.SEARCH_RESULT]: results
      .filter((result) => isFormatTextSearchData(result))
      .map((result: MediocreSearchResult & {data: FormattedTextSearchData}) => ({
        start: result.data.formattedText.start,
        end: result.data.formattedText.end,
        data: {uuid: result.uuid, selected: result.uuid === selected?.uuid},
      })),
  };
}
